<template>
  <normalDialog
    :height="700"
    maxWidth="700"
    :width="700"
    @close="closeDialog"
    scrollable
    :title="$t('label_essweb_approvalTemplate_form_dialog_editNodeTitle')"
    :dialog="show"
  >
    <template v-slot:content>
      <Taber
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
        special
        backgroundColor="white"
      >
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row dense>
              <v-col dense xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :bindData="approvalNodeData.flow_template_node_name"
                  maxlength="100"
                  @change="
                    (valueArr) => {
                      approvalNodeData.flow_template_node_name = valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_approvalTemplate_form_dialog_nodeNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col dense xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :bindData="approvalNodeData.flow_template_node_description"
                  maxlength="500"
                  @change="
                    (valueArr) => {
                      approvalNodeData.flow_template_node_description =
                        valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_approvalTemplate_form_dialog_descriptionLabel'
                    )
                  "
                />
              </v-col>
              <v-col dense xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_approvalTemplate_form_dialog_remarkLabel")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  single-line
                  dense
                  filled
                  counter="500"
                  v-model="approvalNodeData.remarks"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-row dense class="pa-3">
            <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pa-0">
              <v-sheet class="text-subtitle-2">
                {{
                  $t("label_essweb_approvalTemplate_form_dialog_actionLabel")
                }}
              </v-sheet>
              <v-container fluid class="pa-0 ma-0">
                <v-row>
                  <v-col cols="auto" class="py-0">
                    <v-checkbox
                      dense
                      hide-details
                      class="mt-1"
                      v-model="approvalNodeData.is_allow_forward"
                      :label="
                        $t(
                          'label_essweb_approvalTemplate_form_dialog_canRedirectionItemLabel'
                        )
                      "
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="auto" class="py-0">
                    <v-checkbox
                      dense
                      class="mt-1"
                      hide-details
                      v-model="approvalNodeData.is_allow_revoke"
                      :label="
                        $t(
                          'label_essweb_approvalTemplate_form_dialog_canCancelLabel'
                        )
                      "
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="auto" class="py-0">
                    <v-checkbox
                      class="mt-1"
                      dense
                      hide-details
                      v-model="approvalNodeData.is_allow_rollback"
                      :label="
                        $t(
                          'label_essweb_approvalTemplate_form_dialog_canRefusalLabel'
                        )
                      "
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="auto" class="py-0">
                    <v-checkbox
                      class="mt-1"
                      dense
                      hide-details
                      v-model="approvalNodeData.is_allow_skip"
                      :label="
                        $t(
                          'label_essweb_approvalTemplate_form_dialog_canSkipLabel'
                        )
                      "
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="auto" class="py-0">
                    <v-checkbox
                      class="mt-1"
                      dense
                      hide-details
                      v-model="approvalNodeData.is_allow_view_attachments"
                      :label="
                        $t(
                          'label_essweb_approvalTemplate_form_dialog_canViewAttachmentsLabel'
                        )
                      "
                    ></v-checkbox>
                  </v-col> </v-row
              ></v-container>
            </v-col>

            <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pa-0 pt-3">
              <v-sheet class="text-subtitle-2">
                {{
                  $t("label_essweb_approvalTemplate_form_dialog_approverLabel")
                }}
              </v-sheet>
              <v-container fluid class="pa-0 ma-0">
                <v-radio-group v-model="approvers" class="mt-1" hide-details>
                  <!-- 提交人上司 -->
                  <v-radio
                    :label="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_senderSupervisorLabel'
                      )
                    "
                    :value="0"
                  ></v-radio>
                  <!-- 申请人上司 -->
                  <v-radio
                    :label="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_approverSupervisorLabel'
                      )
                    "
                    :value="1"
                  ></v-radio>
                  <!-- 按岗位选择 -->
                  <v-radio
                    :label="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_approverJobLabel'
                      )
                    "
                    :value="2"
                  ></v-radio>
                  <!-- 选择岗位 -->
                  <v-autocomplete
                    v-model="approvalNodeData.forJob"
                    :items="allJob"
                    filled
                    chips
                    class="py-2"
                    dense
                    :filter="jobFliter"
                    multiple
                    v-if="approvers == 2"
                    hide-details
                    single-line
                    color="primary lighten-2"
                    item-text="view_fields"
                    item-value="value_field"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:prepend-item v-if="allJob.length > 0">
                      <v-list-item
                        dense
                        class="px-4"
                        @click="
                          $nextTick(() => {
                            if (
                              approvalNodeData.forJob.length === allJob.length
                            ) {
                              approvalNodeData.forJob = [];
                            } else {
                              approvalNodeData.forJob = [];
                              allJob.map((item) => {
                                approvalNodeData.forJob.push(item.value_field);
                              });
                            }
                          })
                        "
                      >
                        <v-list-item-action class="mx-0 my-0 mr-1">
                          <span
                            class="material-icons-round"
                            :class="
                              approvalNodeData.forJob.length !== 0 &&
                              approvalNodeData.forJob.length === allJob.length
                                ? 'primary--text'
                                : approvalNodeData.forJob.length > 0 &&
                                  approvalNodeData.forJob.length !==
                                    allJob.length
                                ? 'primary--text'
                                : 'text--secondary'
                            "
                          >
                            {{
                              approvalNodeData.forJob.length !== 0 &&
                              approvalNodeData.forJob.length === allJob.length
                                ? "check_box"
                                : approvalNodeData.forJob.length > 0 &&
                                  approvalNodeData.forJob.length !==
                                    allJob.length
                                ? "indeterminate_check_box"
                                : "check_box_outline_blank"
                            }}
                          </span>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{
                              $t("label_essweb_system_select_selectAllLabel")
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        close
                        :input-value="data.selected"
                        @click="data.select"
                        v-if="data.index < $selectSetting.maxChips"
                        @click:close="removeJob(data.item)"
                      >
                        {{ $getCommonLangValue(data.item.view_fields) }}
                      </v-chip>
                      <span
                        v-if="data.index === $selectSetting.maxChips"
                        class="text--primary py-2"
                      >
                        ...{{
                          approvalNodeData.forJob.length -
                          $selectSetting.maxChips
                        }}{{ $t("label_essweb_selection_moreItemLabel") }}
                      </span>
                    </template>
                    <template v-slot:item="data">
                      <v-list class="pa-0" width="100%" nav>
                        <v-list-item rouned width="100%" nav two-line dense>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              $getCommonLangValue(data.item.view_fields)
                            }}</v-list-item-title>
                            <v-list-item-subtitle>{{
                              $getCommonLangValue(data.item.f1)
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                  <!-- 指定员工 -->
                  <v-radio
                    :label="
                      $t('label_essweb_approvalTemplate_form_dialog_staffLabel')
                    "
                    :value="3"
                  ></v-radio>
                  <!--选择员工 -->
                  <v-autocomplete
                    v-model="approvalNodeData.Staffs"
                    :items="allStaff"
                    filled
                    chips
                    class="py-2"
                    dense
                    multiple
                    v-if="approvers == 3"
                    :filter="$staffFilter"
                    hide-details
                    single-line
                    color="primary lighten-2"
                    item-text="staff_code"
                    item-value="staff_id"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:prepend-item v-if="allStaff.length > 0">
                      <v-list-item
                        dense
                        class="px-4"
                        @click="
                          $nextTick(() => {
                            if (
                              approvalNodeData.Staffs.length === allStaff.length
                            ) {
                              approvalNodeData.Staffs = [];
                            } else {
                              approvalNodeData.Staffs = [];
                              allStaff.map((item) => {
                                approvalNodeData.Staffs.push(item.staff_id);
                              });
                            }
                          })
                        "
                      >
                        <v-list-item-action class="mx-0 my-0 mr-1">
                          <span
                            class="material-icons-round"
                            :class="
                              approvalNodeData.Staffs.length !== 0 &&
                              approvalNodeData.Staffs.length === allStaff.length
                                ? 'primary--text'
                                : approvalNodeData.Staffs.length > 0 &&
                                  approvalNodeData.Staffs.length !==
                                    allStaff.length
                                ? 'primary--text'
                                : 'text--secondary'
                            "
                          >
                            {{
                              approvalNodeData.Staffs.length !== 0 &&
                              approvalNodeData.Staffs.length === allStaff.length
                                ? "check_box"
                                : approvalNodeData.Staffs.length > 0 &&
                                  approvalNodeData.Staffs.length !==
                                    allStaff.length
                                ? "indeterminate_check_box"
                                : "check_box_outline_blank"
                            }}
                          </span>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{
                              $t("label_essweb_system_select_selectAllLabel")
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        close
                        v-if="data.index < $selectSetting.maxChips"
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="removeStaff(data.item)"
                      >
                        <StaffAvatar
                          left
                          :src="data.item.staff_avatar"
                          :staff_name="data.item.preferred_name"
                        />

                        {{ $getCommonLangValue(data.item.preferred_name) }}
                      </v-chip>
                      <span
                        v-if="data.index === $selectSetting.maxChips"
                        class="text--primary py-2"
                      >
                        ...{{
                          approvalNodeData.Staffs.length -
                          $selectSetting.maxChips
                        }}{{ $t("label_essweb_selection_moreItemLabel") }}
                      </span>
                    </template>
                    <template v-slot:item="data">
                      <v-list rounded width="100%" nav>
                        <v-list-item rouned width="100%" nav two-line dense>
                          <v-list-item-avatar
                            class="ma-0 mr-1 white--text"
                            size="36"
                          >
                            <StaffAvatar
                              size="36"
                              :src="data.item.staff_avatar"
                              :staff_name="data.item.preferred_name"
                            />
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="text-body-2"
                              >{{
                                $getCommonLangValue(data.item.preferred_name)
                              }}
                              <span class="text--secondary text-caption-xs">{{
                                data.item.staff_code
                              }}</span></v-list-item-title
                            >
                            <v-list-item-subtitle>{{
                              $getCommonLangValue(data.item.job_post_name)
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                  <!-- 节点审批人 -->
                  <v-radio
                    :label="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_nodalApproverLabel'
                      )
                    "
                    :disabled="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      }).length == 0
                    "
                    v-if="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      }).length > 0
                    "
                    :value="4"
                  ></v-radio>
                  <!-- 选择节点 -->
                  <v-autocomplete
                    v-model="approvalNodeData.applicantMan"
                    :items="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      })
                    "
                    filled
                    chips
                    class="py-2"
                    v-if="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      }).length > 0 && approvers == 4
                    "
                    dense
                    hide-details
                    single-line
                    color="primary lighten-2"
                    item-text="flow_template_node_name"
                    item-value="uuid"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        close
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="approvalNodeData.applicantMan = ''"
                      >
                        {{
                          $getCommonLangValue(data.item.flow_template_node_name)
                        }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list rounded width="100%" nav>
                        <v-list-item rouned width="100%">
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_name
                                )
                              "
                            ></v-list-item-title>
                            <v-list-item-subtitle
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_description
                                )
                              "
                            ></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                  <!-- 节点审批上司 -->
                  <v-radio
                    :label="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_nodalApproverSupervisorLabel'
                      )
                    "
                    :disabled="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      }).length == 0
                    "
                    v-if="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      }).length > 0
                    "
                    :value="5"
                  ></v-radio>
                  <!-- 选择上司 -->
                  <v-autocomplete
                    v-model="approvalNodeData.applicantHeader"
                    :items="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      })
                    "
                    filled
                    chips
                    v-if="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      }).length > 0 && approvers == 5
                    "
                    dense
                    class="py-2"
                    hide-details
                    single-line
                    color="primary lighten-2"
                    item-text="flow_template_node_name"
                    item-value="uuid"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        close
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="approvalNodeData.applicantHeader = ''"
                      >
                        {{
                          $getCommonLangValue(data.item.flow_template_node_name)
                        }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list rounded width="100%">
                        <v-list-item rouned width="100%">
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_name
                                )
                              "
                            ></v-list-item-title>
                            <v-list-item-subtitle
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_description
                                )
                              "
                            ></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                  <!-- 所有员工 -->
                  <v-radio
                    :label="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_senderAllSupervisorLabel'
                      )
                    "
                    :value="6"
                  ></v-radio>
                  <!-- 员工关系 -->
                  <v-radio
                    :label="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_senderStaffShipLabel'
                      )
                    "
                    :value="7"
                  ></v-radio>
                  <!--选择员工关系  -->
                  <v-autocomplete
                    v-model="approvalNodeData.correlation"
                    :items="allShip"
                    filled
                    chips
                    class="py-2"
                    dense
                    multiple
                    v-if="approvers == 7"
                    hide-details
                    :filter="shipFliter"
                    single-line
                    color="primary lighten-2"
                    item-text="view_fields"
                    item-value="value_field"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:prepend-item v-if="allShip.length > 0">
                      <v-list-item
                        dense
                        class="px-4"
                        @click="
                          $nextTick(() => {
                            if (
                              approvalNodeData.correlation.length ===
                              allShip.length
                            ) {
                              approvalNodeData.correlation = [];
                            } else {
                              approvalNodeData.correlation = [];
                              allShip.map((item) => {
                                approvalNodeData.correlation.push(
                                  item.value_field
                                );
                              });
                            }
                          })
                        "
                      >
                        <v-list-item-action class="mx-0 my-0 mr-1">
                          <span
                            class="material-icons-round"
                            :class="
                              approvalNodeData.correlation.length !== 0 &&
                              approvalNodeData.correlation.length ===
                                allShip.length
                                ? 'primary--text'
                                : approvalNodeData.correlation.length > 0 &&
                                  approvalNodeData.correlation.length !==
                                    allShip.length
                                ? 'primary--text'
                                : 'text--secondary'
                            "
                          >
                            {{
                              approvalNodeData.correlation.length !== 0 &&
                              approvalNodeData.correlation.length ===
                                allShip.length
                                ? "check_box"
                                : approvalNodeData.correlation.length > 0 &&
                                  approvalNodeData.correlation.length !==
                                    allShip.length
                                ? "indeterminate_check_box"
                                : "check_box_outline_blank"
                            }}
                          </span>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{
                              $t("label_essweb_system_select_selectAllLabel")
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        close
                        v-if="data.index < $selectSetting.maxChips"
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="removeShip(data.item)"
                      >
                        {{ $getCommonLangValue(data.item.view_fields) }}
                      </v-chip>
                      <span
                        v-if="data.index === $selectSetting.maxChips"
                        class="text--primary py-2"
                      >
                        ...{{
                          approvalNodeData.correlation.length -
                          $selectSetting.maxChips
                        }}{{ $t("label_essweb_selection_moreItemLabel") }}
                      </span>
                    </template>
                    <template v-slot:item="data">
                      <v-list rounded width="100%" nav>
                        <v-list-item rouned width="100%" nav>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              $getCommonLangValue(data.item.view_fields)
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </v-radio-group>
              </v-container>
              <!-- bug1451 改为checkbox mel -->
              <!-- <v-item-group v-model="approvers">
                <v-item v-slot:default="{ active, toggle }">
                  <v-row>
                    <v-col md="2" cols="12" class="pa-1 ml-2">
                      <v-btn
                        outlined
                        min-width="80"
                        class="text-capitalize"
                        @click="toggle"
                        :color="active ? 'primary' : 'grey lighten-2'"
                        >{{
                          $t(
                            "label_essweb_approvalTemplate_form_dialog_senderSupervisorLabel"
                          )
                        }}</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-item>
                <v-item v-slot:default="{ active, toggle }">
                  <v-row>
                    <v-col md="2" cols="12" class="pa-1 ml-2">
                      <v-btn
                        outlined
                        class="text-capitalize"
                        min-width="80"
                        @click="toggle"
                        :color="active ? 'primary' : 'grey lighten-2'"
                        >{{
                          $t(
                            "label_essweb_approvalTemplate_form_dialog_approverSupervisorLabel"
                          )
                        }}</v-btn
                      >
                    </v-col></v-row
                  >
                </v-item>
                <v-item v-slot:default="{ active, toggle }">
                  <v-row>
                    <v-col md="2">
                      <v-btn
                        class="text-capitalize"
                        outlined
                        @click="toggle"
                        :color="active ? 'primary' : 'grey lighten-2'"
                        >{{
                          $t(
                            "label_essweb_approvalTemplate_form_dialog_approverJobLabel"
                          )
                        }}</v-btn
                      >
                    </v-col>
                    <v-col  xs='12' sm="12" md='12' lg='12' cols="12" class="pl-3 pt-0" v-if="active">
                      <v-autocomplete
                        v-model="approvalNodeData.forJob"
                        :items="allJob"
                        filled
                        chips
                        multiple
                        v-if="active"
                        hide-details
                        single-line
                        color="primary lighten-2"
                        item-text="view_fields"
                        item-value="value_field"
                      >   <template v-slot:no-data>
                <noContent />
              </template>
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            close
                            :input-value="data.selected"
                            @click="data.select"
                            @click:close="removeJob(data.item)"
                          >
                            {{ $getCommonLangValue(data.item.view_fields) }}
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list rounded width="100%" nav>
                            <v-list-item rouned width="100%" nav>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  $getCommonLangValue(data.item.view_fields)
                                }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-item>
                <v-item v-slot:default="{ active, toggle }">
                  <v-row>
                    <v-col md="2" cols="12" class="pa-1 ml-2">
                      <v-btn
                        outlined
                        class="text-capitalize"
                        @click="toggle"
                        :color="active ? 'primary' : 'grey lighten-2'"
                        >{{
                          $t(
                            "label_essweb_approvalTemplate_form_dialog_staffLabel"
                          )
                        }}</v-btn
                      >
                    </v-col>
                    <v-col md="11" class="pl-3 pt-0" v-if="active">
                      <v-autocomplete
                        v-model="approvalNodeData.Staffs"
                        :items="allStaff"
                        filled
                        chips
                        dense
                        multiple
                        hide-details
                        single-line
                        item-text="preferred_name"
                        item-value="staff_id"
                      >   <template v-slot:no-data>
                <noContent />
              </template>
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            close
                            :input-value="data.selected"
                            @click="data.select"
                            @click:close="removeStaff(data.item)"
                          >
                            <StaffAvatar
                              left
                              :src="data.item.staff_avatar"
                              :staff_name="data.item.preferred_name"
                            />
                            {{ $getCommonLangValue(data.item.preferred_name) }}
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list rounded width="100%" nav two-line dense>
                            <v-list-item rouned width="100%" nav dense>
                              <v-list-item-avatar
                                class="ma-0 mr-1 white--text"
                                size="36"
                              >
                                <StaffAvatar
                                  size="36"
                                  :src="data.item.staff_avatar"
                                  :staff_name="data.item.preferred_name"
                                />
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  $getCommonLangValue(data.item.preferred_name)
                                }}</v-list-item-title>
                                <v-list-item-subtitle>{{
                                  $getCommonLangValue(data.item.dept_all)
                                }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-item>
                <v-item v-slot:default="{ active, toggle }">
                  <v-row>
                    <v-col md="2" cols="12" class="pa-1 ml-2">
                      <v-btn
                        outlined
                        class="text-capitalize"
                        min-width="80"
                        :style="{
                          cursor:
                            allNode.length == 0 ? 'not-allowed' : 'pointer',
                        }"
                        @click="
                          () => {
                            if (allNode.length > 0) {
                              toggle();
                            }
                          }
                        "
                        :color="active ? 'primary' : 'grey lighten-2'"
                        >{{
                          $t(
                            "label_essweb_approvalTemplate_form_dialog_nodalApproverLabel"
                          )
                        }}</v-btn
                      >
                    </v-col>
                    <v-col md="11" cols="12" class="pl-3 pt-0" v-if="active">
                      <v-autocomplete
                        v-model="approvalNodeData.applicantMan"
                        :items="allNode"
                        filled
                        chips
                        hide-details
                        single-line
                        item-text="flow_template_node_name"
                        :item-value="curUuid ? 'uuid' : 'number'"
                      >   <template v-slot:no-data>
                <noContent />
              </template>
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            close
                            :input-value="data.selected"
                            @click="data.select"
                            @click:close="approvalNodeData.applicantMan = ''"
                          >
                            {{
                              $getCommonLangValue(
                                data.item.flow_template_node_name
                              )
                            }}
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list rounded width="100%" nav>
                            <v-list-item rouned width="100%">
                              <v-list-item-content>
                                <v-list-item-title
                                  v-html="
                                    $getCommonLangValue(
                                      data.item.flow_template_node_name
                                    )
                                  "
                                ></v-list-item-title>
                                <v-list-item-subtitle
                                  v-html="
                                    $getCommonLangValue(
                                      data.item.flow_template_node_description
                                    )
                                  "
                                ></v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-item>
                <v-item v-slot:default="{ active, toggle }">
                  <v-row>
                    <v-col md="2" cols="12" class="pa-1 ml-2">
                      <v-btn
                        outlined
                        class="text-capitalize"
                        min-width="80"
                        :style="{
                          cursor:
                            allNode.length == 0 ? 'not-allowed' : 'pointer',
                        }"
                        @click="
                          () => {
                            if (allNode.length > 0) {
                              toggle();
                            }
                          }
                        "
                        :color="active ? 'primary' : 'grey lighten-2'"
                        >{{
                          $t(
                            "label_essweb_approvalTemplate_form_dialog_nodalApproverSupervisorLabel"
                          )
                        }}</v-btn
                      >
                    </v-col>
                    <v-col md="11" cols="12" class="pl-3 pt-0" v-if="active">
                      <v-autocomplete
                        v-model="approvalNodeData.applicantHeader"
                        :items="allNode"
                        filled
                        chips
                        hide-details
                        single-line
                        color="primary lighten-2"
                        item-text="flow_template_node_name"
                        :item-value="curUuid ? 'uuid' : 'number'"
                      >   <template v-slot:no-data>
                <noContent />
              </template>
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            close
                            :input-value="data.selected"
                            @click="data.select"
                            @click:close="approvalNodeData.applicantHeader = ''"
                          >
                            {{
                              $getCommonLangValue(
                                data.item.flow_template_node_name
                              )
                            }}
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list rounded width="100%">
                            <v-list-item rouned width="100%">
                              <v-list-item-content>
                                <v-list-item-title
                                  v-html="
                                    $getCommonLangValue(
                                      data.item.flow_template_node_name
                                    )
                                  "
                                ></v-list-item-title>
                                <v-list-item-subtitle
                                  v-html="
                                    $getCommonLangValue(
                                      data.item.flow_template_node_description
                                    )
                                  "
                                ></v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-item>
                <v-item v-slot:default="{ active, toggle }">
                  <v-row>
                    <v-col md="2" cols="12" class="pa-1 ml-2">
                      <v-btn
                        outlined
                        min-width="80"
                        class="text-capitalize"
                        @click="toggle"
                        :color="active ? 'primary' : 'grey lighten-2'"
                        >{{
                          $t(
                            "label_essweb_approvalTemplate_form_dialog_senderAllSupervisorLabel"
                          )
                        }}</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-item>
              </v-item-group> -->
            </v-col>
            <!-- 抄送 -->
            <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pa-0 pt-3">
              <v-sheet class="text-subtitle-2">
                {{
                  $t("label_essweb_approvalTemplate_form_dialog_emailCCLabel")
                }}
              </v-sheet>
              <v-container fluid class="pa-0 ma-0">
                <v-radio-group v-model="copySender" class="mt-1" hide-details>
                  <v-radio
                    :label="
                      $t('label_essweb_approvalTemplate_form_dialog_notCCLabel')
                    "
                    :value="-1"
                  ></v-radio>
                  <!-- 提交人上司 -->
                  <v-radio
                    :label="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_senderSupervisorLabel'
                      )
                    "
                    :value="0"
                  ></v-radio>
                  <!-- 申请人上司 -->
                  <v-radio
                    :label="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_approverSupervisorLabel'
                      )
                    "
                    :value="1"
                  ></v-radio>
                  <!-- 按岗位选择 -->
                  <v-radio
                    :label="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_approverJobLabel'
                      )
                    "
                    :value="2"
                  ></v-radio>
                  <!-- 选择岗位 -->
                  <v-autocomplete
                    v-model="approvalNodeData.forJob_cc"
                    :items="allJob"
                    filled
                    chips
                    class="py-2"
                    dense
                    :filter="jobFliter"
                    multiple
                    v-if="copySender == 2"
                    hide-details
                    single-line
                    color="primary lighten-2"
                    item-text="view_fields"
                    item-value="value_field"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:prepend-item v-if="allJob.length > 0">
                      <v-list-item
                        dense
                        class="px-4"
                        @click="
                          $nextTick(() => {
                            if (
                              approvalNodeData.forJob_cc.length ===
                              allJob.length
                            ) {
                              approvalNodeData.forJob_cc = [];
                            } else {
                              approvalNodeData.forJob_cc = [];
                              allJob.map((item) => {
                                approvalNodeData.forJob_cc.push(
                                  item.value_field
                                );
                              });
                            }
                          })
                        "
                      >
                        <v-list-item-action class="mx-0 my-0 mr-1">
                          <span
                            class="material-icons-round"
                            :class="
                              approvalNodeData.forJob_cc.length !== 0 &&
                              approvalNodeData.forJob_cc.length ===
                                allJob.length
                                ? 'primary--text'
                                : approvalNodeData.forJob_cc.length > 0 &&
                                  approvalNodeData.forJob_cc.length !==
                                    allJob.length
                                ? 'primary--text'
                                : 'text--secondary'
                            "
                          >
                            {{
                              approvalNodeData.forJob_cc.length !== 0 &&
                              approvalNodeData.forJob_cc.length ===
                                allJob.length
                                ? "check_box"
                                : approvalNodeData.forJob_cc.length > 0 &&
                                  approvalNodeData.forJob_cc.length !==
                                    allJob.length
                                ? "indeterminate_check_box"
                                : "check_box_outline_blank"
                            }}
                          </span>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{
                              $t("label_essweb_system_select_selectAllLabel")
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        close
                        :input-value="data.selected"
                        @click="data.select"
                        v-if="data.index < $selectSetting.maxChips"
                        @click:close="removeJob(data.item, true)"
                      >
                        {{ $getCommonLangValue(data.item.view_fields) }}
                      </v-chip>
                      <span
                        v-if="data.index === $selectSetting.maxChips"
                        class="text--primary py-2"
                      >
                        ...{{
                          approvalNodeData.forJob_cc.length -
                          $selectSetting.maxChips
                        }}{{ $t("label_essweb_selection_moreItemLabel") }}
                      </span>
                    </template>
                    <template v-slot:item="data">
                      <v-list class="pa-0" width="100%" nav>
                        <v-list-item rouned width="100%" nav two-line dense>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              $getCommonLangValue(data.item.view_fields)
                            }}</v-list-item-title>
                            <v-list-item-subtitle>{{
                              $getCommonLangValue(data.item.f1)
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                  <!-- 指定员工 -->
                  <v-radio
                    :label="
                      $t('label_essweb_approvalTemplate_form_dialog_staffLabel')
                    "
                    :value="3"
                  ></v-radio>
                  <!--选择员工 -->
                  <v-autocomplete
                    v-model="approvalNodeData.Staffs_cc"
                    :items="allStaff"
                    filled
                    chips
                    class="py-2"
                    dense
                    multiple
                    v-if="copySender == 3"
                    :filter="$staffFilter"
                    hide-details
                    single-line
                    color="primary lighten-2"
                    item-text="staff_code"
                    item-value="staff_id"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:prepend-item v-if="allStaff.length > 0">
                      <v-list-item
                        dense
                        class="px-4"
                        @click="
                          $nextTick(() => {
                            if (
                              approvalNodeData.Staffs_cc.length ===
                              allStaff.length
                            ) {
                              approvalNodeData.Staffs_cc = [];
                            } else {
                              approvalNodeData.Staffs_cc = [];
                              allStaff.map((item) => {
                                approvalNodeData.Staffs_cc.push(item.staff_id);
                              });
                            }
                          })
                        "
                      >
                        <v-list-item-action class="mx-0 my-0 mr-1">
                          <span
                            class="material-icons-round"
                            :class="
                              approvalNodeData.Staffs_cc.length !== 0 &&
                              approvalNodeData.Staffs_cc.length ===
                                allStaff.length
                                ? 'primary--text'
                                : approvalNodeData.Staffs_cc.length > 0 &&
                                  approvalNodeData.Staffs_cc.length !==
                                    allStaff.length
                                ? 'primary--text'
                                : 'text--secondary'
                            "
                          >
                            {{
                              approvalNodeData.Staffs_cc.length !== 0 &&
                              approvalNodeData.Staffs_cc.length ===
                                allStaff.length
                                ? "check_box"
                                : approvalNodeData.Staffs_cc.length > 0 &&
                                  approvalNodeData.Staffs_cc.length !==
                                    allStaff.length
                                ? "indeterminate_check_box"
                                : "check_box_outline_blank"
                            }}
                          </span>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{
                              $t("label_essweb_system_select_selectAllLabel")
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        close
                        pill
                        v-if="data.index < $selectSetting.maxChips"
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="removeStaff(data.item, true)"
                      >
                        <StaffAvatar
                          left
                          :src="data.item.staff_avatar"
                          :staff_name="data.item.preferred_name"
                        />

                        {{ $getCommonLangValue(data.item.preferred_name) }}
                      </v-chip>
                      <span
                        v-if="data.index === $selectSetting.maxChips"
                        class="text--primary py-2"
                      >
                        ...{{
                          approvalNodeData.Staffs_cc.length -
                          $selectSetting.maxChips
                        }}{{ $t("label_essweb_selection_moreItemLabel") }}
                      </span>
                    </template>
                    <template v-slot:item="data">
                      <v-list rounded width="100%" nav>
                        <v-list-item rouned width="100%" nav two-line dense>
                          <v-list-item-avatar
                            class="ma-0 mr-1 white--text"
                            size="36"
                          >
                            <StaffAvatar
                              size="36"
                              :src="data.item.staff_avatar"
                              :staff_name="data.item.preferred_name"
                            />
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="text-body-2"
                              >{{
                                $getCommonLangValue(data.item.preferred_name)
                              }}
                              <span class="text--secondary text-caption-xs">{{
                                data.item.staff_code
                              }}</span></v-list-item-title
                            >
                            <v-list-item-subtitle>{{
                              $getCommonLangValue(data.item.job_post_name)
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                  <!-- 节点审批人 -->
                  <v-radio
                    :label="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_nodalApproverLabel'
                      )
                    "
                    :disabled="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      }).length == 0
                    "
                    v-if="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      }).length > 0
                    "
                    :value="4"
                  ></v-radio>
                  <!-- 选择节点 -->
                  <v-autocomplete
                    v-model="approvalNodeData.applicantMan_cc"
                    :items="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      })
                    "
                    v-if="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      }).length > 0 && copySender == 4
                    "
                    filled
                    chips
                    class="py-2"
                    dense
                    hide-details
                    single-line
                    color="primary lighten-2"
                    item-text="flow_template_node_name"
                    item-value="uuid"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        close
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="approvalNodeData.applicantMan_cc = ''"
                      >
                        {{
                          $getCommonLangValue(data.item.flow_template_node_name)
                        }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list rounded width="100%" nav>
                        <v-list-item rouned width="100%">
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_name
                                )
                              "
                            ></v-list-item-title>
                            <v-list-item-subtitle
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_description
                                )
                              "
                            ></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                  <!-- 节点审批上司 -->
                  <v-radio
                    :label="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_nodalApproverSupervisorLabel'
                      )
                    "
                    :disabled="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      }).length == 0
                    "
                    v-if="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      }).length > 0
                    "
                    :value="5"
                  ></v-radio>
                  <!-- 选择上司 -->
                  <v-autocomplete
                    v-model="approvalNodeData.applicantHeader_cc"
                    :items="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      })
                    "
                    v-if="
                      allNode.filter((ele) => {
                        return ele.uuid !== curUuid;
                      }).length > 0 && copySender == 5
                    "
                    filled
                    chips
                    dense
                    class="py-2"
                    hide-details
                    single-line
                    color="primary lighten-2"
                    item-text="flow_template_node_name"
                    item-value="uuid"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        close
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="approvalNodeData.applicantHeader_cc = ''"
                      >
                        {{
                          $getCommonLangValue(data.item.flow_template_node_name)
                        }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list rounded width="100%">
                        <v-list-item rouned width="100%">
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_name
                                )
                              "
                            ></v-list-item-title>
                            <v-list-item-subtitle
                              v-html="
                                $getCommonLangValue(
                                  data.item.flow_template_node_description
                                )
                              "
                            ></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                  <!-- 所有员工 -->
                  <v-radio
                    v-if="0"
                    :label="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_senderAllSupervisorLabel'
                      )
                    "
                    :value="6"
                  ></v-radio>
                  <!-- 员工关系 -->
                  <v-radio
                    :label="
                      $t(
                        'label_essweb_approvalTemplate_form_dialog_senderStaffShipLabel'
                      )
                    "
                    :value="7"
                  ></v-radio>
                  <!--选择员工关系  -->
                  <v-autocomplete
                    v-model="approvalNodeData.correlation_cc"
                    :items="allShip"
                    filled
                    chips
                    class="py-2"
                    dense
                    multiple
                    v-if="copySender == 7"
                    hide-details
                    :filter="shipFliter"
                    single-line
                    color="primary lighten-2"
                    item-text="view_fields"
                    item-value="value_field"
                  >
                    <template v-slot:no-data>
                      <noContent />
                    </template>
                    <template v-slot:prepend-item v-if="allShip.length > 0">
                      <v-list-item
                        dense
                        class="px-4"
                        @click="
                          $nextTick(() => {
                            if (
                              approvalNodeData.correlation_cc.length ===
                              allShip.length
                            ) {
                              approvalNodeData.correlation_cc = [];
                            } else {
                              approvalNodeData.correlation_cc = [];
                              allShip.map((item) => {
                                approvalNodeData.correlation_cc.push(
                                  item.value_field
                                );
                              });
                            }
                          })
                        "
                      >
                        <v-list-item-action class="mx-0 my-0 mr-1">
                          <span
                            class="material-icons-round"
                            :class="
                              approvalNodeData.correlation_cc.length !== 0 &&
                              approvalNodeData.correlation_cc.length ===
                                allShip.length
                                ? 'primary--text'
                                : approvalNodeData.correlation_cc.length > 0 &&
                                  approvalNodeData.correlation_cc.length !==
                                    allShip.length
                                ? 'primary--text'
                                : 'text--secondary'
                            "
                          >
                            {{
                              approvalNodeData.correlation_cc.length !== 0 &&
                              approvalNodeData.correlation_cc.length ===
                                allShip.length
                                ? "check_box"
                                : approvalNodeData.correlation_cc.length > 0 &&
                                  approvalNodeData.correlation_cc.length !==
                                    allShip.length
                                ? "indeterminate_check_box"
                                : "check_box_outline_blank"
                            }}
                          </span>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{
                              $t("label_essweb_system_select_selectAllLabel")
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        close
                        v-if="data.index < $selectSetting.maxChips"
                        :input-value="data.selected"
                        @click="data.select"
                        @click:close="removeShip(data.item, true)"
                      >
                        {{ $getCommonLangValue(data.item.view_fields) }}
                      </v-chip>
                      <span
                        v-if="data.index === $selectSetting.maxChips"
                        class="text--primary py-2"
                      >
                        ...{{
                          approvalNodeData.correlation_cc.length -
                          $selectSetting.maxChips
                        }}{{ $t("label_essweb_selection_moreItemLabel") }}
                      </span>
                    </template>
                    <template v-slot:item="data">
                      <v-list rounded width="100%" nav>
                        <v-list-item rouned width="100%" nav>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              $getCommonLangValue(data.item.view_fields)
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </v-radio-group>
              </v-container>
            </v-col>
            <!-- 抄送 -->
            <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pa-0 pt-3">
              <v-sheet class="text-subtitle-2">
                {{
                  $t(
                    "label_essweb_approvalTemplate_form_dialog_IsNotificationLabel"
                  )
                }}
              </v-sheet>
              <v-container fluid class="pa-0 ma-0">
                <v-row>
                  <v-col
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    cols="auto"
                    class="py-0"
                  >
                    <v-checkbox
                      dense
                      class="mt-1"
                      hide-details
                      v-model="approvalNodeData.is_alert_notification"
                      :label="
                        $t(
                          'label_essweb_approvalTemplate_form_dialog_notificationLabel'
                        )
                      "
                    ></v-checkbox>
                  </v-col>
                  <v-col
                    xs="12"
                    sm="12"
                    md="6"
                    lg="6"
                    cols="12"
                    v-if="approvalNodeData.is_alert_notification"
                  >
                    <numberInputTextFiled
                      :rules="
                        $GetRules(
                          ['_Number_negative', '_Length_Rules'],
                          [null, 11]
                        )
                      "
                      v-model="approvalNodeData.approver_notify_threshold"
                      :label="
                        $t(
                          'label_essweb_approvalTemplate_form_dialog_approvalNotiOverDateLabel'
                        )
                      "
                      isNotRequire
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </template>
        <template v-slot:content-3>
          <v-form ref="form2" lazy-validation>
            <v-row>
              <v-col dense xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_approvalTemplate_form_dialog_filedLabel")
                }}</v-sheet>
                <v-autocomplete
                  :items="allField"
                  item-text="view_fields"
                  item-value="value_field"
                  small-chips
                  dense
                  single-line
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  deletable-chips
                  v-model="approvalNodeData.field_uuid"
                  multiple
                  filled
                >
                  <template v-slot:no-data>
                    <noContent />
                  </template>
                  <template v-slot:prepend-item v-if="allField.length > 0">
                    <v-list-item
                      dense
                      class="px-4"
                      @click="
                        $nextTick(() => {
                          if (
                            approvalNodeData.field_uuid.length ===
                            allField.length
                          ) {
                            approvalNodeData.field_uuid = [];
                          } else {
                            approvalNodeData.field_uuid = [];
                            allField.map((item) => {
                              approvalNodeData.field_uuid.push(
                                item.value_field
                              );
                            });
                          }
                        })
                      "
                    >
                      <v-list-item-action class="mx-0 my-0 mr-1">
                        <span
                          class="material-icons-round"
                          :class="
                            approvalNodeData.field_uuid.length !== 0 &&
                            approvalNodeData.field_uuid.length ===
                              allField.length
                              ? 'primary--text'
                              : approvalNodeData.field_uuid.length > 0 &&
                                approvalNodeData.field_uuid.length !==
                                  allField.length
                              ? 'primary--text'
                              : 'text--secondary'
                          "
                        >
                          {{
                            approvalNodeData.field_uuid.length !== 0 &&
                            approvalNodeData.field_uuid.length ===
                              allField.length
                              ? "check_box"
                              : approvalNodeData.field_uuid.length > 0 &&
                                approvalNodeData.field_uuid.length !==
                                  allField.length
                              ? "indeterminate_check_box"
                              : "check_box_outline_blank"
                          }}
                        </span>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{
                            $t("label_essweb_system_select_selectAllLabel")
                          }}</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                  </template>
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      close
                      :input-value="data.selected"
                      v-if="data.index < $selectSetting.maxChips"
                      @click="data.select"
                      @click:close="removeUuid(data.item)"
                    >
                      {{ $getCommonLangValue(data.item.view_fields) }}
                    </v-chip>
                    <span
                      v-if="data.index === $selectSetting.maxChips"
                      class="text--primary py-2"
                    >
                      ...{{
                        approvalNodeData.field_uuid.length -
                        $selectSetting.maxChips
                      }}{{ $t("label_essweb_selection_moreItemLabel") }}
                    </span>
                  </template>

                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="data.item.view_fields"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </template>
      </Taber>
    </template>
    <template v-slot:actions>
      <CardActions saveBtn @save="toSave" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "newApprovalDialog",
  computed: {
    ...mapGetters(["companyLang", "staticZone", "AppInfo"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
  },
  props: {
    show: { default: false, type: Boolean },
    PropertyData: { default: null, type: Object },
    allNode: {
      default: () => {
        return [];
      },
      type: [Array, Function],
    },
    table: { default: "", type: String },
    curUuid: { default: "", type: String },
  },
  watch: {
    curUuid(val) {
      //在线编辑
      if (val) {
        this.getDetail(val);
      }
    },
    PropertyData(obj) {
      this.curTab = "tab-1";
      const that = this;
      if (obj) {
        this.actions = [];
        obj.is_allow_forward ? this.actions.push(0) : null;
        obj.is_allow_revoke ? this.actions.push(1) : null;
        obj.is_allow_rollback ? this.actions.push(2) : null;
        obj.is_allow_skip ? this.actions.push(3) : null;
        obj.is_allow_view_attachments ? this.actions.push(4) : null;
        this.approvalNodeData.is_first_sequence = obj.is_first_sequence;
        this.approvalNodeData.is_final_sequence = obj.is_final_sequence;
        this.notifications = [];
        obj.is_alert_notification ? this.notifications.push(0) : null;
        // 2021-01-11 改为一个通知 brain
        // obj.is_alert_notification ? this.notifications.push(0) : null;
        // obj.is_alert_prev_approver ? this.notifications.push(1) : null;
        this.approvers = -1;
        obj.ess_workflow_template_node_permission[0].is_leader_of_sender === 0
          ? (this.approvers = 0)
          : null;
        obj.ess_workflow_template_node_permission[0].is_leader_of_sender === 1
          ? (this.approvers = 0)
          : null;
        obj.ess_workflow_template_node_permission[0].is_leader_of_applicant
          ? (this.approvers = 1)
          : null;
        obj.ess_workflow_template_node_permission[0].approval_postion_uuid
          ? (this.approvers = 2)
          : null;
        obj.ess_workflow_template_node_permission[0].approval_staff_uuid
          ? (this.approvers = 3)
          : null;
        if (
          obj.ess_workflow_template_node_permission[0].pre_node_approver !==
            null &&
          obj.ess_workflow_template_node_permission[0].pre_node_approver !== ""
        ) {
          this.approvers = 4;
        }
        if (
          obj.ess_workflow_template_node_permission[0]
            .pre_node_approver_leader !== null &&
          obj.ess_workflow_template_node_permission[0]
            .pre_node_approver_leader !== ""
        ) {
          this.approvers = 5;
        }
        obj.ess_workflow_template_node_permission[0].approval_org_level_uuid
          ? (that.approvers = 6)
          : null;
        obj.ess_workflow_template_node_permission[0].correlation_uuid
          ? (that.approvers = 7)
          : null;
        // 抄送
        this.copySender = -1;
        obj.ess_workflow_template_node_permission[0].cc_is_leader_of_sender ===
        null
          ? (this.copySender = 0)
          : null;
        obj.ess_workflow_template_node_permission[0].cc_is_leader_of_sender ===
        0
          ? (this.copySender = 0)
          : null;
        obj.ess_workflow_template_node_permission[0].cc_is_leader_of_sender ===
        1
          ? (this.copySender = 0)
          : null;
        obj.ess_workflow_template_node_permission[0].cc_is_leader_of_applicant
          ? (this.copySender = 1)
          : null;
        obj.ess_workflow_template_node_permission[0].cc_approval_postion_uuid
          ? (this.copySender = 2)
          : null;
        obj.ess_workflow_template_node_permission[0].cc_approval_staff_uuid
          ? (this.copySender = 3)
          : null;
        if (
          obj.ess_workflow_template_node_permission[0].cc_pre_node_approver !==
            null &&
          obj.ess_workflow_template_node_permission[0].cc_pre_node_approver !==
            ""
        ) {
          this.copySender = 4;
        }
        if (
          obj.ess_workflow_template_node_permission[0]
            .cc_pre_node_approver_leader !== null &&
          obj.ess_workflow_template_node_permission[0]
            .cc_pre_node_approver_leader !== ""
        ) {
          this.copySender = 5;
        }
        obj.ess_workflow_template_node_permission[0].cc_approval_org_level_uuid
          ? (that.copySender = 6)
          : null;
        obj.ess_workflow_template_node_permission[0].cc_correlation_uuid
          ? (that.copySender = 7)
          : null;
        //抄送
        this.approvalNodeData.flow_template_node_name =
          this.$transOnLineCommonLangKey(
            this.companyLang,
            obj.flow_template_node_name
          );
        this.approvalNodeData.flow_template_node_description =
          this.$transOnLineCommonLangKey(
            this.companyLang,
            obj.flow_template_node_description
          );

        this.approvalNodeData.applicantMan =
          obj.ess_workflow_template_node_permission[0].pre_node_approver;
        this.approvalNodeData.applicantHeader =
          obj.ess_workflow_template_node_permission[0].pre_node_approver_leader;
        let job = obj.ess_workflow_template_node_permission[0]
          .approval_postion_uuid
          ? obj.ess_workflow_template_node_permission[0].approval_postion_uuid.split(
              ","
            )
          : [];
        that.approvalNodeData.forJob = [];
        job.map((item) => {
          that.approvalNodeData.forJob.push(item);
        });
        let ship = obj.ess_workflow_template_node_permission[0].correlation_uuid
          ? obj.ess_workflow_template_node_permission[0].correlation_uuid.split(
              ","
            )
          : [];
        that.approvalNodeData.correlation = [];
        ship.map((item) => {
          that.approvalNodeData.correlation.push(item);
        });
        that.approvalNodeData.Staffs = [];
        let staff = obj.ess_workflow_template_node_permission[0]
          .approval_staff_uuid
          ? obj.ess_workflow_template_node_permission[0].approval_staff_uuid.split(
              ","
            )
          : [];
        staff.map((item) => {
          that.approvalNodeData.Staffs.push(Number(item));
        });
        // 抄送
        this.approvalNodeData.applicantMan_cc =
          obj.ess_workflow_template_node_permission[0].cc_pre_node_approver;
        this.approvalNodeData.applicantHeader_cc =
          obj.ess_workflow_template_node_permission[0].cc_pre_node_approver_leader;
        let job_cc = obj.ess_workflow_template_node_permission[0]
          .cc_approval_postion_uuid
          ? obj.ess_workflow_template_node_permission[0].cc_approval_postion_uuid.split(
              ","
            )
          : [];
        that.approvalNodeData.forJob_cc = [];
        job_cc.map((item) => {
          that.approvalNodeData.forJob_cc.push(item);
        });
        let ship_cc = obj.ess_workflow_template_node_permission[0]
          .cc_correlation_uuid
          ? obj.ess_workflow_template_node_permission[0].cc_correlation_uuid.split(
              ","
            )
          : [];
        that.approvalNodeData.correlation_cc = [];
        ship.map((item) => {
          that.approvalNodeData.correlation_cc.push(item);
        });
        that.approvalNodeData.Staffs_cc = [];
        let staff_cc = obj.ess_workflow_template_node_permission[0]
          .cc_approval_staff_uuid
          ? obj.ess_workflow_template_node_permission[0].cc_approval_staff_uuid.split(
              ","
            )
          : [];
        staff_cc.map((item) => {
          that.approvalNodeData.Staffs_cc.push(Number(item));
        });
        // 抄送
        this.approvalNodeData.field_uuid =
          obj.ess_workflow_template_node_allow_update_fields[0].field_uuid.split(
            ","
          );
        this.approvalNodeData.remarks = obj.remarks;
        this.approvalNodeData["number"] = obj.number;
        this.approvalNodeData["id"] = obj.id;
        this.approvalNodeData["approver_notify_threshold"] =
          obj.approver_notify_threshold;
      }
    },
    show(val) {
      // if (!val) {
      //   this.approvalNodeData.is_allow_forward = false;
      //   this.approvalNodeData.is_allow_revoke = false;
      //   this.approvalNodeData.is_allow_rollback = false;
      //   this.approvalNodeData.is_first_sequence = false;
      //   this.approvalNodeData.is_final_sequence = false;
      //   this.approvalNodeData.is_alert_notification = false;
      //   this.approvalNodeData.is_alert_prev_approver = false;
      //   this.approvalNodeData.is_leader_of_sender = false;
      //   this.approvalNodeData.is_leader_of_applicant = true;
      //   this.approvalNodeData.is_for_job = false;
      //   this.approvalNodeData.is_for_staff = false;
      //   this.approvalNodeData.is_for_applicant = false;
      //   this.approvalNodeData.is_for_applicantheader = false;
      //   this.approvalNodeData.applicantMan = "";
      //   this.approvalNodeData.applicantHeader = "";
      //   this.approvalNodeData.Staffs = "";
      //   this.approvalNodeData.field_uuid = [];
      //   this.curTab = "tab-1";
      //   if (this.$refs["form"]) this.$refs["form"].reset();
      //   if (this.$refs["form2"]) this.$refs["form2"].reset();
      // }
      if (val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
        // this.approvalNodeData.approver_notify_threshold = 0;
        if (this.$refs["form2"]) this.$refs["form2"].reset();
      }
      if (!val) this.allField = [];
      this.curTab = "tab-1";
      if (this.allStaff.length == 0)
        this.$getStaffList().then((res) => {
          this.allStaff = res;
        });
      if (this.allField.length == 0 && this.table != "")
        this.getField(this.table);
    },
    table(val) {
      if (val) {
        this.getField(val);
      }
    },
    actions(val) {
      const index0 = val.indexOf(0);
      const index1 = val.indexOf(1);
      const index2 = val.indexOf(2);
      const index3 = val.indexOf(3);
      const index4 = val.indexOf(4);
      this.approvalNodeData.is_allow_forward = false;
      this.approvalNodeData.is_allow_revoke = false;
      this.approvalNodeData.is_allow_rollback = false;
      this.approvalNodeData.is_allow_skip = false;
      this.approvalNodeData.is_allow_view_attachments = false;

      if (index0 >= 0) {
        this.approvalNodeData.is_allow_forward = true;
      }
      if (index1 >= 0) {
        this.approvalNodeData.is_allow_revoke = true;
      }
      if (index2 >= 0) {
        this.approvalNodeData.is_allow_rollback = true;
      }
      if (index3 >= 0) {
        this.approvalNodeData.is_allow_skip = true;
      }
      if (index4 >= 0) {
        this.approvalNodeData.is_allow_view_attachments = true;
      }
    },
    nodes(val) {
      this.approvalNodeData.is_first_sequence = false;
      this.approvalNodeData.is_final_sequence = false;
      switch (val) {
        case 0:
          this.approvalNodeData.is_first_sequence = true;
          break;
        case 1:
          // this.approvalNodeData.
          break;
        case 2:
          this.approvalNodeData.is_final_sequence = true;
          break;
        default:
          break;
      }
    },
    notifications(val) {
      const index0 = val.indexOf(0);
      // const index1 = val.indexOf(1);
      this.approvalNodeData.is_alert_notification = false;
      // this.approvalNodeData.is_alert_notification = false;
      // this.approvalNodeData.is_alert_prev_approver = false;
      // 2021-01-11 改为一个通知 brain
      // if (index0 >= 0) {
      //   this.approvalNodeData.is_alert_notification = true;
      // }
      // if (index1 >= 0) {
      //   this.approvalNodeData.is_alert_prev_approver = true;
      // }
      if (index0 >= 0) {
        this.approvalNodeData.is_alert_notification = true;
      }
    },
    copySender(val) {
      if (val == -1 || val == null || val == 0 || val == 1) {
        this.approvalNodeData.forJob_cc = [];
        this.approvalNodeData.Staffs_cc = [];
        this.approvalNodeData.correlation_cc = [];
        this.approvalNodeData.applicantMan_cc = "";
        this.approvalNodeData.applicantHeader_cc = "";
      }
      if (val == 2) {
        this.approvalNodeData.Staffs_cc = [];
        this.approvalNodeData.correlation_cc = [];
        this.approvalNodeData.applicantMan_cc = "";
        this.approvalNodeData.applicantHeader_cc = "";
      }
      if (val == 3) {
        this.approvalNodeData.forJob_cc = [];
        this.approvalNodeData.applicantMan_cc = "";
        this.approvalNodeData.correlation_cc = [];
        this.approvalNodeData.applicantHeader_cc = "";
      }
      if (val == 4) {
        this.approvalNodeData.forJob_cc = [];
        this.approvalNodeData.Staffs_cc = [];
        this.approvalNodeData.correlation_cc = [];
        this.approvalNodeData.applicantHeader_cc = "";
      }
      if (val == 5) {
        this.approvalNodeData.Staffs_cc = [];
        this.approvalNodeData.forJob_cc = [];
        this.approvalNodeData.correlation_cc = [];
        this.approvalNodeData.applicantMan_cc = "";
      }
      if (val == 6) {
        this.approvalNodeData.forJob_cc = [];
        this.approvalNodeData.Staffs_cc = [];
        this.approvalNodeData.applicantMan_cc = "";
        this.approvalNodeData.correlation_cc = [];
        this.approvalNodeData.applicantHeader_cc = "";
      }
      if (val == 7) {
        this.approvalNodeData.forJob_cc = [];
        this.approvalNodeData.Staffs_cc = [];
        this.approvalNodeData.applicantMan_cc = "";
        this.approvalNodeData.applicantHeader_cc = "";
      }
      this.approvalNodeData.is_leader_of_sender_cc = false;
      this.approvalNodeData.is_leader_of_applicant_cc = false;
      this.approvalNodeData.is_for_job_cc = false;
      this.approvalNodeData.is_for_ship_cc = false;
      this.approvalNodeData.is_for_staff_cc = false;
      this.approvalNodeData.is_for_applicant_cc = false;
      this.approvalNodeData.is_for_applicantheader_cc = false;
      this.approvalNodeData.approval_org_level_uuid_cc = "";
      switch (val) {
        case null:
          this.approvalNodeData.is_leader_of_sender_cc = false;
          break;
        case 0:
          this.approvalNodeData.is_leader_of_sender_cc = true;
          break;
        case 1:
          this.approvalNodeData.is_leader_of_applicant_cc = true;
          break;
        case 2:
          this.approvalNodeData.is_for_job_cc = true;
          break;
        case 3:
          this.approvalNodeData.is_for_staff_cc = true;
          break;
        case 4:
          this.approvalNodeData.is_for_applicant_cc = true;
          break;
        case 5:
          this.approvalNodeData.is_for_applicantheader_cc = true;
          break;
        case 6:
          this.approvalNodeData.approval_org_level_uuid_cc =
            this.curAppInfo["user"]["org_level_uuid"];
          break;
        case 7:
          this.approvalNodeData.is_for_ship_cc = true;
          break;
        default:
          break;
      }
    },
    approvers(val) {
      if (val == 0 || val == 1) {
        this.approvalNodeData.forJob = [];
        this.approvalNodeData.Staffs = [];
        this.approvalNodeData.correlation = [];
        this.approvalNodeData.applicantMan = "";
        this.approvalNodeData.applicantHeader = "";
      }
      if (val == 2) {
        this.approvalNodeData.Staffs = [];
        this.approvalNodeData.correlation = [];
        this.approvalNodeData.applicantMan = "";
        this.approvalNodeData.applicantHeader = "";
      }
      if (val == 3) {
        this.approvalNodeData.forJob = [];
        this.approvalNodeData.applicantMan = "";
        this.approvalNodeData.correlation = [];
        this.approvalNodeData.applicantHeader = "";
      }
      if (val == 4) {
        this.approvalNodeData.forJob = [];
        this.approvalNodeData.Staffs = [];
        this.approvalNodeData.correlation = [];
        this.approvalNodeData.applicantHeader = "";
      }
      if (val == 5) {
        this.approvalNodeData.Staffs = [];
        this.approvalNodeData.forJob = [];
        this.approvalNodeData.correlation = [];
        this.approvalNodeData.applicantMan = "";
      }
      if (val == 6) {
        this.approvalNodeData.forJob = [];
        this.approvalNodeData.Staffs = [];
        this.approvalNodeData.applicantMan = "";
        this.approvalNodeData.correlation = [];
        this.approvalNodeData.applicantHeader = "";
      }
      if (val == 7) {
        this.approvalNodeData.forJob = [];
        this.approvalNodeData.Staffs = [];
        this.approvalNodeData.applicantMan = "";
        this.approvalNodeData.applicantHeader = "";
      }
      this.approvalNodeData.is_leader_of_sender = false;
      this.approvalNodeData.is_leader_of_applicant = false;
      this.approvalNodeData.is_for_job = false;
      this.approvalNodeData.is_for_ship = false;
      this.approvalNodeData.is_for_staff = false;
      this.approvalNodeData.is_for_applicant = false;
      this.approvalNodeData.is_for_applicantheader = false;
      this.approvalNodeData.approval_org_level_uuid = "";
      switch (val) {
        case 0:
          this.approvalNodeData.is_leader_of_sender = true;
          break;
        case 1:
          this.approvalNodeData.is_leader_of_applicant = true;
          break;
        case 2:
          this.approvalNodeData.is_for_job = true;
          break;
        case 3:
          this.approvalNodeData.is_for_staff = true;
          break;
        case 4:
          this.approvalNodeData.is_for_applicant = true;
          break;
        case 5:
          this.approvalNodeData.is_for_applicantheader = true;
          break;
        case 6:
          this.approvalNodeData.approval_org_level_uuid =
            this.curAppInfo["user"]["org_level_uuid"];
          break;
        case 7:
          this.approvalNodeData.is_for_ship = true;
          break;
        default:
          break;
      }
    },
  },
  data() {
    return {
      curTab: "tab-1",
      taber: [
        "label_essweb_approvalTemplate_form_dialog_step_generalLabel",
        "label_essweb_approvalTemplate_form_dialog_step_permissionLabel",
        "label_essweb_approvalTemplate_form_dialog_step_fieldLabel",
      ],
      actions: [],
      nodes: 1,
      allJob: [],
      allShip: [],
      allStaff: [],
      allField: [],
      notifications: [],
      approvers: "",
      copySender: -1,
      approvalNodeData: {
        approver_notify_threshold: null,
        flow_template_node_name: "",
        flow_template_node_description: "",
        is_allow_forward: false,
        is_allow_revoke: false,
        is_allow_rollback: false,
        is_allow_skip: false,
        is_allow_view_attachments: false,
        is_first_sequence: false,
        is_final_sequence: false,
        // is_alert_notification: false,
        is_alert_notification: false,
        // is_alert_prev_approver: false,
        is_leader_of_sender: true,
        is_leader_of_sender_cc: false,
        is_leader_of_applicant: false,
        is_leader_of_applicant_cc: false,
        is_for_job: false,
        is_for_job_cc: false,
        forJob: [],
        forJob_cc: [],
        is_for_ship: false,
        is_for_ship_cc: false,
        correlation: [],
        correlation_cc: [],
        approval_org_level_uuid: null,
        approval_org_level_uuid_cc: null,
        is_for_staff: false,
        is_for_staff_cc: false,
        field_uuid: [],
        Staffs: [],
        Staffs_cc: [],
        is_for_applicant: false,
        is_for_applicant_cc: false,
        applicantMan: "",
        applicantMan_cc: "",
        is_for_applicantheader: false,
        is_for_applicantheader_cc: false,
        applicantHeader: "",
        applicantHeader_cc: "",
        ess_workflow_template_node_allow_update_fields: [],
        ess_workflow_template_node_permission: [],
        remarks: "",
      },
      approversgangwei: [],
    };
  },
  mounted() {
    const that = this;
    this.approvalNodeData.flow_template_node_name = this.$getCommonLangKey(
      this.companyLang
    );
    this.approvalNodeData.flow_template_node_description =
      this.$getCommonLangKey(this.companyLang);
    this.getJob();
    this.getShip();
    this.$getStaffList().then((res) => {
      this.allStaff = res;
    });
  },
  methods: {
    jobFliter(item, queryText) {
      if (queryText) {
        let itemText = "view_fields";
        if (!this.$getCommonLangValue(item[itemText])) return false;
        const one_filter = this.$getCommonLangValue(
          item[itemText]
        ).toLowerCase();

        const searchtext = String(queryText).toLowerCase();

        return one_filter.indexOf(searchtext) > -1;
      } else return true;
    },
    shipFliter(item, queryText) {
      if (queryText) {
        let itemText = "view_fields";
        if (!this.$getCommonLangValue(item[itemText])) return false;
        const one_filter = this.$getCommonLangValue(
          item[itemText]
        ).toLowerCase();

        const searchtext = String(queryText).toLowerCase();

        return one_filter.indexOf(searchtext) > -1;
      } else return true;
    },
    removeUuid: function (item) {
      const index = this.approvalNodeData.field_uuid.indexOf(item.value_field);
      if (index >= 0) this.approvalNodeData.field_uuid.splice(index, 1);
    },
    getDetail: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_template_nodes",
        url: "/approval-node/get-approval-node-details/",
        data: {
          uuid: uuid,
        },
      }).then((res) => {
        let obj = res.data;
        that.curTab = "tab-1";
        if (obj) {
          that.actions = [];
          obj.is_allow_forward ? that.actions.push(0) : null;
          obj.is_allow_revoke ? that.actions.push(1) : null;
          obj.is_allow_rollback ? that.actions.push(2) : null;
          obj.is_allow_skip ? that.actions.push(3) : null;
          obj.is_allow_view_attachments ? that.actions.push(4) : null;
          that.approvalNodeData.is_first_sequence = obj.is_first_sequence;
          that.approvalNodeData.is_final_sequence = obj.is_final_sequence;
          that.notifications = [];
          obj.is_alert_notification ? that.notifications.push(0) : null;
          // 2021-01-11 改为一个通知 brain
          // obj.is_alert_notification ? that.notifications.push(0) : null;
          // obj.is_alert_prev_approver ? that.notifications.push(1) : null;
          that.approvers = -1;
          obj.ess_workflow_template_node_permission[0].is_leader_of_sender === 1
            ? (that.approvers = 0)
            : null;
          obj.ess_workflow_template_node_permission[0].is_leader_of_applicant
            ? (that.approvers = 1)
            : null;
          obj.ess_workflow_template_node_permission[0].approval_postion_uuid
            ? (that.approvers = 2)
            : null;
          obj.ess_workflow_template_node_permission[0].approval_staff_uuid
            ? (that.approvers = 3)
            : null;
          obj.ess_workflow_template_node_permission[0].pre_node_approver == null
            ? null
            : (that.approvers = 4);
          obj.ess_workflow_template_node_permission[0]
            .pre_node_approver_leader == null
            ? null
            : (that.approvers = 5);
          obj.ess_workflow_template_node_permission[0].approval_org_level_uuid
            ? (that.approvers = 6)
            : null;
          obj.ess_workflow_template_node_permission[0].correlation_uuid
            ? (that.approvers = 7)
            : null;
          // 抄送
          that.copySender = -1;
          obj.ess_workflow_template_node_permission[0].cc_is_leader_of_sender ==
          0
            ? (that.copySender = -1)
            : null;
          obj.ess_workflow_template_node_permission[0]
            .cc_is_leader_of_sender === 1
            ? (that.copySender = 0)
            : null;
          obj.ess_workflow_template_node_permission[0].cc_is_leader_of_applicant
            ? (that.copySender = 1)
            : null;
          obj.ess_workflow_template_node_permission[0].cc_approval_postion_uuid
            ? (that.copySender = 2)
            : null;
          obj.ess_workflow_template_node_permission[0].cc_approval_staff_uuid
            ? (that.copySender = 3)
            : null;
          obj.ess_workflow_template_node_permission[0].cc_pre_node_approver ==
          null
            ? null
            : (that.copySender = 4);
          obj.ess_workflow_template_node_permission[0]
            .cc_pre_node_approver_leader == null
            ? null
            : (that.copySender = 5);
          obj.ess_workflow_template_node_permission[0]
            .cc_approval_org_level_uuid
            ? (that.copySender = 6)
            : null;
          obj.ess_workflow_template_node_permission[0].cc_correlation_uuid
            ? (that.copySender = 7)
            : null;
          // 抄送
          that.approvalNodeData["flow_template_node_description_save"] =
            obj.flow_template_node_description;
          that.approvalNodeData["flow_template_node_name_save"] =
            obj.flow_template_node_name;
          that.approvalNodeData.flow_template_node_name =
            that.$transOnLineCommonLangKey(
              that.companyLang,
              obj.flow_template_node_name
            );
          that.approvalNodeData.flow_template_node_description =
            that.$transOnLineCommonLangKey(
              that.companyLang,
              obj.flow_template_node_description
            );

          that.approvalNodeData.applicantMan =
            obj.ess_workflow_template_node_permission[0].pre_node_approver;
          that.approvalNodeData.applicantHeader =
            obj.ess_workflow_template_node_permission[0].pre_node_approver_leader;
          that.approvalNodeData.forJob = obj
            .ess_workflow_template_node_permission[0].approval_postion_uuid
            ? obj.ess_workflow_template_node_permission[0].approval_postion_uuid.split(
                ","
              )
            : [];
          that.approvalNodeData.Staffs = [];
          that.approvalNodeData.correlation = obj
            .ess_workflow_template_node_permission[0].correlation_uuid
            ? obj.ess_workflow_template_node_permission[0].correlation_uuid.split(
                ","
              )
            : [];
          let staff = obj.ess_workflow_template_node_permission[0]
            .approval_staff_uuid
            ? obj.ess_workflow_template_node_permission[0].approval_staff_uuid.split(
                ","
              )
            : [];
          staff.map((item) => {
            that.approvalNodeData.Staffs.push(Number(item));
          });
          // 抄送
          that.approvalNodeData.applicantMan_cc =
            obj.ess_workflow_template_node_permission[0].cc_pre_node_approver;
          that.approvalNodeData.applicantHeader_cc =
            obj.ess_workflow_template_node_permission[0].cc_pre_node_approver_leader;
          that.approvalNodeData.forJob_cc = obj
            .ess_workflow_template_node_permission[0].cc_approval_postion_uuid
            ? obj.ess_workflow_template_node_permission[0].cc_approval_postion_uuid.split(
                ","
              )
            : [];
          that.approvalNodeData.Staffs_cc = [];
          that.approvalNodeData.correlation_cc = obj
            .ess_workflow_template_node_permission[0].cc_correlation_uuid
            ? obj.ess_workflow_template_node_permission[0].cc_correlation_uuid.split(
                ","
              )
            : [];
          let staff_cc = obj.ess_workflow_template_node_permission[0]
            .cc_approval_staff_uuid
            ? obj.ess_workflow_template_node_permission[0].cc_approval_staff_uuid.split(
                ","
              )
            : [];
          staff_cc.map((item) => {
            that.approvalNodeData.Staffs_cc.push(Number(item));
          });

          // 抄送
          that.approvalNodeData.field_uuid =
            obj.ess_workflow_template_node_allow_update_fields[0].field_uuid.split(
              ","
            );
          that.approvalNodeData.remarks = obj.remarks;
          this.approvalNodeData["uuid"] = obj.uuid;
          this.approvalNodeData["nodeuuid"] =
            obj.ess_workflow_template_node_allow_update_fields[0].uuid;
          this.approvalNodeData["number"] = null;
          this.approvalNodeData["id"] = null;
          that.approvalNodeData.approver_notify_threshold =
            obj.approver_notify_threshold;
        }
      });
    },
    getJob: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_job_posts_select",
      }).then((res) => {
        that.allJob = res.data;
      });
    },
    getShip: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "correlation_select",
      }).then((res) => {
        that.allShip = res.data;
      });
    },
    getField: function (table) {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_approval_allow_update_columns_select",

        table_uuid: table,
      }).then((res) => {
        that.allField = res.data;
      });
    },
    // 改为底层接口 daveluo
    // getStaff: function () {
    //   const that = this;
    //   this.$Request({
    //     method: "POST",
    //     table: "mrbase_sys_staffs",
    //     url: "/staff/get-staff-list/",

    //   }).then((res) => {
    //     that.allStaff = res.data;
    //   });
    // },

    closeDialog: function () {
      this.$emit("close");
    },
    removeStaff: function (item, cc) {
      if (cc) {
        this.approvalNodeData.Staffs_cc =
          this.approvalNodeData.Staffs_cc.filter(
            (ele) => Number(ele) !== Number(item.staff_id)
          );
      } else
        this.approvalNodeData.Staffs = this.approvalNodeData.Staffs.filter(
          (ele) => Number(ele) !== Number(item.staff_id)
        );
    },
    removeJob: function (item, cc) {
      if (cc) {
        this.approvalNodeData.forJob_cc =
          this.approvalNodeData.forJob_cc.filter(
            (ele) => ele !== item.value_field
          );
      } else
        this.approvalNodeData.forJob = this.approvalNodeData.forJob.filter(
          (ele) => ele !== item.value_field
        );
    },
    removeShip: function (item, cc) {
      if (cc) {
        this.approvalNodeData.correlation_cc =
          this.approvalNodeData.correlation_cc.filter(
            (ele) => ele !== item.value_field
          );
      } else
        this.approvalNodeData.correlation =
          this.approvalNodeData.correlation.filter(
            (ele) => ele !== item.value_field
          );
    },
    toSave: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      if (this.$refs["form2"]) {
        if (!this.$refs["form2"].validate()) {
          this.$showMessage({
            title: this.$t("message_essweb_form_textField_noticeTitle"),
            okText: this.$t("message_essweb_form_textField_fillInAgain"),
            text: this.$t("message_essweb_form_textField_notIncorrect_content"),
            type: "warning",
          });
          return false;
        }
      }
      if (
        (this.approvers == 2 && this.approvalNodeData.forJob.length == 0) ||
        (this.copySender == 2 && this.approvalNodeData.forJob_cc.length == 0)
      ) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_selectAgain"),
          text: this.$t(
            "message_essweb_approvalTemplate_form_selectMemberLabel"
          ),
          type: "warning",
        });
        return false;
      }
      if (
        (this.approvers == 7 &&
          this.approvalNodeData.correlation.length == 0) ||
        (this.copySender == 7 &&
          this.approvalNodeData.correlation_cc.length == 0)
      ) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_selectAgain"),
          text: this.$t(
            "message_essweb_approvalTemplate_form_selectMemberLabel"
          ),
          type: "warning",
        });
        return false;
      }
      if (
        (this.approvers == 3 && this.approvalNodeData.Staffs.length == 0) ||
        (this.copySender == 3 && this.approvalNodeData.Staffs_cc.length == 0)
      ) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_selectAgain"),
          text: this.$t(
            "message_essweb_approvalTemplate_form_selectMemberLabel"
          ),
          type: "warning",
        });
        return false;
      }
      if (
        (this.approvers == 4 && this.approvalNodeData.applicantMan === "") ||
        (this.copySender == 4 && this.approvalNodeData.applicantMan_cc === "")
      ) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_selectAgain"),
          text: this.$t(
            "message_essweb_approvalTemplate_form_selectMemberLabel"
          ),
          type: "warning",
        });
        return false;
      }
      if (
        (this.approvers == 5 && this.approvalNodeData.applicantHeader === "") ||
        (this.copySender == 5 &&
          this.approvalNodeData.applicantHeader_cc === "")
      ) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_selectAgain"),
          text: this.$t(
            "message_essweb_approvalTemplate_form_selectHeaderLabel"
          ),
          type: "warning",
        });
        return false;
      }
      // 2020-03-05 修改为不必填 BJ

      // if (this.approvalNodeData.field_uuid.length == 0) {
      //   this.$showMessage({
      //
      //
      // title: this.$t("message_essweb_form_textField_noticeTitle"),
      // okText: this.$t("message_essweb_form_textField_fillInAgain"),
      // text: this.$t("message_essweb_form_textField_notIncorrect_content"),
      //     type: "warning",
      //   });
      //   return false;
      // }
      let data = null;
      if (this.curUuid) {
        data = {
          id: this.approvalNodeData.id,
          approver_notify_threshold:
            this.approvalNodeData.approver_notify_threshold,
          uuid: this.approvalNodeData.uuid,
          number: this.approvalNodeData.number,
          flow_template_node_name: this.$transCommonLangKey(
            this.approvalNodeData.flow_template_node_name,
            this.approvalNodeData.flow_template_node_name_save
          ),
          flow_template_node_description: this.$transCommonLangKey(
            this.approvalNodeData.flow_template_node_description,
            this.approvalNodeData.flow_template_node_description_save
          ),
          is_allow_forward: this.approvalNodeData.is_allow_forward ? 1 : 0,
          is_allow_revoke: this.approvalNodeData.is_allow_revoke ? 1 : 0,
          is_allow_rollback: this.approvalNodeData.is_allow_rollback ? 1 : 0,
          is_allow_skip: this.approvalNodeData.is_allow_skip ? 1 : 0,
          is_allow_view_attachments: this.approvalNodeData
            .is_allow_view_attachments
            ? 1
            : 0,
          is_alert_notification: this.approvalNodeData.is_alert_notification
            ? 1
            : 0,
          // is_alert_notification: this.approvalNodeData.is_alert_notification ? 1 : 0,
          is_first_sequence: this.approvalNodeData.is_first_sequence,
          is_final_sequence: this.approvalNodeData.is_final_sequence,
          // is_alert_prev_approver: this.approvalNodeData.is_alert_prev_approver
          //   ? 1
          //   : 0,
          ess_workflow_template_node_allow_update_fields: [
            {
              uuid: this.approvalNodeData["nodeuuid"],
              field_uuid: this.approvalNodeData.field_uuid.join(","),
            },
          ],
          ess_workflow_template_node_permission: [
            {
              is_leader_of_sender: this.approvalNodeData.is_leader_of_sender
                ? 1
                : 0,
              is_leader_of_applicant: this.approvalNodeData
                .is_leader_of_applicant
                ? 1
                : 0,
              approval_postion_uuid: this.approvalNodeData.forJob.join(","),
              correlation_uuid: this.approvalNodeData.correlation.join(","),
              approval_staff_uuid: this.approvalNodeData.Staffs.join(","),
              pre_node_approver: this.approvalNodeData.applicantMan,
              pre_node_approver_leader: this.approvalNodeData.applicantHeader,
              approval_org_level_uuid:
                this.approvalNodeData.approval_org_level_uuid,
              // 抄送
              cc_is_leader_of_sender: this.approvalNodeData
                .is_leader_of_sender_cc
                ? 1
                : 0,
              cc_is_leader_of_applicant: this.approvalNodeData
                .is_leader_of_applicant_cc
                ? 1
                : 0,
              cc_approval_postion_uuid:
                this.approvalNodeData.forJob_cc.join(","),
              cc_approval_staff_uuid: this.approvalNodeData.Staffs_cc.join(","),
              cc_pre_node_approver: this.approvalNodeData.applicantMan_cc,
              cc_pre_node_approver_leader:
                this.approvalNodeData.applicantHeader_cc,
              cc_approval_org_level_uuid:
                this.approvalNodeData.approval_org_level_uuid_cc,
              cc_correlation_uuid:
                this.approvalNodeData.correlation_cc.join(","),
            },
          ],
          remarks: this.approvalNodeData.remarks,
        };
      } else {
        data = {
          id: this.approvalNodeData.id,
          approver_notify_threshold:
            this.approvalNodeData.approver_notify_threshold,
          number: this.approvalNodeData.number,
          flow_template_node_name: this.$transCommonLangKey(
            this.approvalNodeData.flow_template_node_name
          ),
          flow_template_node_description: this.$transCommonLangKey(
            this.approvalNodeData.flow_template_node_description
          ),
          is_allow_forward: this.approvalNodeData.is_allow_forward ? 1 : 0,
          is_allow_revoke: this.approvalNodeData.is_allow_revoke ? 1 : 0,
          is_allow_rollback: this.approvalNodeData.is_allow_rollback ? 1 : 0,
          is_allow_skip: this.approvalNodeData.is_allow_skip ? 1 : 0,
          is_allow_view_attachments: this.approvalNodeData
            .is_allow_view_attachments
            ? 1
            : 0,
          is_alert_notification: this.approvalNodeData.is_alert_notification
            ? 1
            : 0,
          // is_alert_notification: this.approvalNodeData.is_alert_notification ? 1 : 0,
          is_first_sequence: this.allNode.length > 0 ? 0 : 1,
          is_final_sequence: this.allNode.length > 0 ? 1 : 0,
          // is_alert_prev_approver: this.approvalNodeData.is_alert_prev_approver
          //   ? 1
          //   : 0,
          ess_workflow_template_node_allow_update_fields: [
            { field_uuid: this.approvalNodeData.field_uuid.join(",") },
          ],
          ess_workflow_template_node_permission: [
            {
              is_leader_of_sender: this.approvalNodeData.is_leader_of_sender
                ? 1
                : 0,
              is_leader_of_applicant: this.approvalNodeData
                .is_leader_of_applicant
                ? 1
                : 0,
              approval_postion_uuid: this.approvalNodeData.forJob.join(","),
              correlation_uuid: this.approvalNodeData.correlation.join(","),
              approval_staff_uuid: this.approvalNodeData.Staffs.join(","),
              pre_node_approver: this.approvalNodeData.applicantMan,
              pre_node_approver_leader: this.approvalNodeData.applicantHeader,
              approval_org_level_uuid:
                this.approvalNodeData.approval_org_level_uuid,
              // 抄送
              cc_is_leader_of_sender: this.approvalNodeData
                .is_leader_of_sender_cc
                ? 1
                : 0,
              cc_is_leader_of_applicant: this.approvalNodeData
                .is_leader_of_applicant_cc
                ? 1
                : 0,
              cc_approval_postion_uuid:
                this.approvalNodeData.forJob_cc.join(","),
              cc_approval_staff_uuid: this.approvalNodeData.Staffs_cc.join(","),
              cc_pre_node_approver: this.approvalNodeData.applicantMan_cc,
              cc_pre_node_approver_leader:
                this.approvalNodeData.applicantHeader_cc,
              cc_approval_org_level_uuid:
                this.approvalNodeData.approval_org_level_uuid_cc,
              cc_correlation_uuid:
                this.approvalNodeData.correlation_cc.join(","),
            },
          ],
          remarks: this.approvalNodeData.remarks,
        };
      }
      this.$emit("onEdit", data);
    },
  },
};
</script>
